export default __webpack_public_path__ + "static/media/telegram-blue.335c7c60.svg";